module.exports = __webpack_public_path__ + "static/img/2tgimg.d501303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2tgimg.jpg
// module id = 9Qj1
// module chunks = 2